import { IDotsToastLocalization } from "dots-ui/dotsToast";
import { ResCallback } from "../models";

export const toastLocalization = (res: ResCallback): IDotsToastLocalization => {
  return {
    copy: res("button_Copy"),
    closeToastTooltip: res("tooltip_Close"),
    correlationId: res("common_ErrorId"),
    errorDescription: res("common_Description"),
    expandDetails: res("common_ExpandDetails"),
    hideDetails: res("common_HideDetails"),
  };
};
